import {ActiveRecord} from './ActiveRecord';
import config from 'config';
import { TYPE_BINGO, TYPE_BEST_PLAYER, TYPE_MATCH_RESULT } from './voting/base';
import BingoVoting from './voting/bingo';
import BestPlayerVoting from './voting/bestPlayer';
import MatchResultVoting from './voting/matchResult';
import votingLoader from './voting/loader';

export default class Event extends ActiveRecord {
  static path = `${config.backOfficeBasePath}/events`;

  static validateConstraints = {
    first_partc: {
      presence: true
    },
    second_partc: {
      notEquality: 'first_partc',
      presence: true
    },
    start_time: {
      presence: true
    },
    end_time: {
      presence: true,
      greaterThan: {key: 'start_time'}
    }
  };

  static getEventAttr(type) {
    switch (type) {
      case TYPE_BINGO:
        return 'bingoVoting';
      case TYPE_BEST_PLAYER:
        return 'bestPlayerVoting';
      case TYPE_MATCH_RESULT:
        return 'matchResultVoting';
      default:
        throw 'Undefined type of voting';
    }
  }

  static mapRecords(data) {
    return data.map((item) => new Event(item));
  }

  get bingoVoting() {
    return this._bingoVoting;
  }

  set bingoVoting(voting) {
    if (voting instanceof BingoVoting) {
      this._bingoVoting = voting;
    } else if(this._bingoVoting !== undefined && this._bingoVoting instanceof BingoVoting) {
      Object.assign(this._bingoVoting, voting);
    } else {
      this._bingoVoting = new BingoVoting(voting);
    }
  }

  set bestPlayerVoting(voting) {
    if (voting instanceof BestPlayerVoting) {
      this._bestPlayerVoting = voting;
    } else if(this._bestPlayerVoting !== undefined && this._bestPlayerVoting instanceof BestPlayerVoting) {
      Object.assign(this._bestPlayerVoting, voting);
    } else {
      this._bestPlayerVoting = new BestPlayerVoting(voting);
    }
  }

  get bestPlayerVoting() {
    return this._bestPlayerVoting;
  }

  set matchResultVoting(voting) {
    let currentVoting = this._matchResultVoting;

    if (voting instanceof MatchResultVoting) {
      currentVoting = voting;
    } else if(currentVoting !== undefined && currentVoting instanceof MatchResultVoting) {
      Object.assign(currentVoting, voting);
    } else {
      currentVoting = new MatchResultVoting(voting);
    }

    this._matchResultVoting = currentVoting;
  }

  get matchResultVoting() {
    return this._matchResultVoting;
  }

  _getModel() {
    return Event;
  }

  prepareForSave(data) {
    let { first_partc, second_partc, start_time, end_time } = data;

    return {
      first_partc,
      second_partc,
      start_time: start_time ? start_time.getTime() : undefined,
      end_time: end_time ? end_time.getTime() : undefined
    };
  }

  fetch() {
    let eventId = this.id;

    return Promise.all([
      super.fetch(),
      votingLoader(eventId)
        .then((votings) => Promise.all([
          this._parseVoting('bingoVoting', BingoVoting)(votings),
          this._parseVoting('bestPlayerVoting', BestPlayerVoting)(votings),
          this._parseVoting('matchResultVoting', MatchResultVoting)(votings)
        ]))
    ])
      .then(() => this);
  }

  _parseVoting(key, objectClass) {
    return (votings) => {
      let bingos = votings.filter(item => item instanceof objectClass);
      if (bingos.length > 0) {
        this[key] = bingos[0];
      }
      return votings;
    };
  }

  save(data) {
    return Promise.resolve(super.save(data))
      // updateVoting
      .then(() => Promise.all([
            this.saveRelated('bingoVoting'),
            this.saveRelated('bestPlayerVoting'),
            this.saveRelated('matchResultVoting')
          ])
      );
  }

  saveRelated(key) {
    let relatedObject = this[key];

    if (relatedObject !== undefined) {
      if (relatedObject.isNew()) {
        relatedObject.eventId = this.id;
      }

      return relatedObject.save()
        .catch((res) => Promise.reject({[key]: res}));
    }
    return Promise.resolve();
  }

  setData(data) {
    let { first_partc, second_partc, start_time, end_time } = data;

    Object.assign(this, { first_partc, second_partc, start_time, end_time });

    return this;
  }

}



// WEBPACK FOOTER //
// ./src/api/event.js